import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../Translations/LenguageContext";
import MandatorySign from "../../../Components/MandatorySign";
import ErrorMessage from "../../../Components/ErrorMessage";
import Spinner from "../../../Components/Spinner";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const UpdatePromptRLStatusModal = ({
    account_id,
    org_id,
    geo_id,
    show,
    handleClose,
    selectedPrompt,
    selectedStatusRL,
    getPrompts
}) => {
    const { t } = useLanguage()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const [formData, setFormData] = useState({
        rl_reason: "",
    });

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSave = async () => {
        if (!formData.rl_reason.trim()) {
            setErrorMessage({ message: t.geo.reason_required, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/rl_status_prompt`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    geo_id,
                    prompt_id: selectedPrompt.id,
                    rl_status: selectedStatusRL,
                    rl_reason: formData.rl_reason
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            if (data.message == "OK") {
                getPrompts()
                closeModal()
            }

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const closeModal = () => {
        setFormData({
            prompt: "",
        })

        setLoadingSave(false);
        setErrorMessage({ message: "", display: false });
        handleClose()
    }

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.geo.classify_prompt}</p>
            </div>
            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div className="label_input">
                        <label className="input_label">
                            {t.geo.why_is_prompt} {t.geo[selectedStatusRL]} <MandatorySign message={t.mandatory_field} />
                        </label>
                        <textarea
                            name="rl_reason"
                            maxLength={300}
                            value={formData.rl_reason}
                            onChange={handleChange}
                            placeholder={`${t.geo.classify_placeholder} ${t.geo[selectedStatusRL]}`}
                            className="register_form_first textarea_reg fade-in"
                            autoComplete="off"
                        />
                    </div>          
                    <p className="warning_source_message fade-in" dangerouslySetInnerHTML={{__html: t.geo.classify_warning}}></p>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default UpdatePromptRLStatusModal;